import React from 'react';
import { ModalFactory } from 'components';
import { appConfig } from 'config/app';
import { AltAlertContent } from '../NoCalculatorRulesModal/NoCalculatorRulesModal';

const IntegrationRequiredModal = ({ hideModal }: { hideModal: () => void }) => (
  <ModalFactory customModal onClose={hideModal} isActive>
    <AltAlertContent
      hideLeftAction
      title="Integration Required"
      message="To use this feature, you'll need to integrate your Point of Sale (POS) system. Please contact support to learn more about the integration process."
      rightActionLabel="Contact Support"
      onClose={hideModal}
      onRightAction={() => window.open(appConfig.LINKS.SUPPORT)}
    />
  </ModalFactory>
);

export default IntegrationRequiredModal;
